import { Form, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Select, { BaseOptionType } from "antd/lib/select";

const getPayoutScheduleOptions = () => {
  return [
    { label: "Daily", value: "daily" },
    { label: "Weekly Wed", value: "weekly-wed" },
    { label: "Weekly Thur", value: "weekly-thur" },
    { label: "Weekly Fri", value: "weekly-fri" },
    { label: "Monthly", value: "monthly" },
  ] as BaseOptionType[];
};

export default function PayoutDetailsEditor() {
  const bankFieldLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
  };

  return (
    <>
      <Form.Item
        label={
          <span>
            Payout Schedule{" "}
            <Tooltip title="Payout frequency changes apply automatically to Adyen, but not to Rapyd. If this merchant uses both acquirers, updating this setting will sync the new frequency to Adyen only. Rapyd payout frequency must be updated separately.">
              <InfoCircleOutlined style={{ color: "rgba(0,0,0,0.45)" }} />
            </Tooltip>
          </span>
        }
        name={["payoutOptions", "schedule"]}
        wrapperCol={{ ...bankFieldLayout.wrapperCol }}
        labelCol={{ ...bankFieldLayout.labelCol }}
        labelAlign="left"
      >
        <Select
          style={{ width: 200 }}
          options={getPayoutScheduleOptions()}
        />
      </Form.Item>
    </>
  );
}
